import type { SceneOptions } from '../../core/Scene';
import { Scene } from '../../core/Scene';
import { Container } from '../display';
import type { Entity2D } from './Entity2D';
import { View2DSystem } from './view/View2DSystem';

export class Scene2D extends Scene {
  public view2d: View2DSystem;

  constructor(options: SceneOptions & { stage: Container }) {
    super(options);

    this.register('onGameover');
    this.register('onGameComplete');

    this.view2d = this.addSystem(View2DSystem, { stage: options.stage });
  }

  public addChild(...entities: Entity2D[]): void {
    if (entities.length > 1) {
      for (let i = 0; i < entities.length; i++) {
        this.addToScene(entities[i]);
      }
    } else {
      this.addToScene(entities[0]);
    }
  }

  public removeChild(...entities: Entity2D[]): void {
    if (entities.length > 1) {
      for (let i = 0; i < entities.length; i++) {
        this.removeFromScene(entities[i]);
      }
    } else {
      this.removeFromScene(entities[0]);
    }
  }
}
